<mat-toolbar
  *ngIf="{
    orderId: orderId$ | async,
  } as data"
  [class.full-size-logo]="settings.HeaderLogoWithoutPaddings"
  [class.show-logo-only]="showLogoOnly"
>
  <div class="logo">
    <a
      [routerLink]="[catalog.name, currentLang()]"
      [queryParams]="{ OrderId: adminCartMode ? data.orderId : null }"
      (click)="activeRouteId != RouteId.ObjectChoice ? onHomeClick() : null"
    >
      <img [src]="catalog.logoUrl" alt="Home" />
    </a>
    @if(catalog.status === 'Test'){
    <div class="test-mode-hint">{{ 'TEST_MODE_HINT' | translate }}</div>
    }
  </div>

  <div *ngIf="catalog.environmentName !== 'Production'" class="environment">{{ catalog.environmentName }}</div>

  <div class="editing-order" *ngIf="adminCartMode">
    <ng-container *ngIf="order$ | async as order">
      <div
        *ngIf="order.oldId"
        class="old-id"
        tippy="{{ 'ORDER.OLD_ID' | translate }}: {{ order.oldId }}"
        translate="ORDER.HAS_OLD_ID"
      ></div>
      <span
        translate="CART.EDIT_ORDER_HEADING"
        [translateParams]="{
          creator: order.customer.firstName + ' ' + order.customer.lastName,
          orderNumber: order.orderNumber
        }"
      ></span>
    </ng-container>
    <span *ngIf="(cart$ | async)?.isBlockCart">{{ 'OBJECT_CHOICE.TITLE_EDIT_BLOCKS' | translate }}</span>
  </div>

  <div class="icons-wrapper">
    @if (isSmallScreen$ | async) {
    <a
      mat-icon-button
      class="calendar"
      [class.active]="activeRouteId === RouteId.ObjectChoice"
      [routerLink]="[catalog.name, currentLang()]"
      [queryParams]="{ OrderId: adminCartMode ? data.orderId : null }"
      (click)="activeRouteId != RouteId.ObjectChoice ? onHomeClick() : null"
      [tippy]="'NAVIGATION.CHOICES' | translate"
      [attr.aria-label]="'NAVIGATION.CHOICES' | translate"
    >
      <mat-icon>date_range</mat-icon>
    </a>
    } @else {
    <a
      mat-button
      class="calendar"
      [class.active]="activeRouteId === RouteId.ObjectChoice"
      [routerLink]="[catalog.name, currentLang()]"
      [queryParams]="{ OrderId: adminCartMode ? data.orderId : null }"
      (click)="activeRouteId != RouteId.ObjectChoice ? onHomeClick() : null"
      [tippy]="'NAVIGATION.CHOICES' | translate"
      [attr.aria-label]="'NAVIGATION.CHOICES' | translate"
    >
      <mat-icon>date_range</mat-icon>
    </a>
    } @if (isSmallScreen$ | async) {
    <a
      mat-icon-button
      class="cart"
      [matBadge]="cartCount$ | async"
      [matBadgeHidden]="((cartCount$ | async) ?? 0) <= 0 || activeRouteId === RouteId.OrderStatus"
      [routerLink]="[catalog.name, currentLang(), 'cart']"
      [queryParams]="{ OrderId: adminCartMode ? data.orderId : null }"
      routerLinkActive="active"
      [tippy]="'NAVIGATION.CART' | translate"
      [attr.aria-label]="'NAVIGATION.CART' | translate"
    >
      <mat-icon>shopping_cart</mat-icon>
    </a>
    } @else {
    <a
      mat-button
      class="cart"
      [matBadge]="cartCount$ | async"
      [matBadgeHidden]="((cartCount$ | async) ?? 0) <= 0 || activeRouteId === RouteId.OrderStatus"
      [routerLink]="[catalog.name, currentLang(), 'cart']"
      [queryParams]="{ OrderId: adminCartMode ? data.orderId : null }"
      routerLinkActive="active"
      [tippy]="'NAVIGATION.CART' | translate"
      [attr.aria-label]="'NAVIGATION.CART' | translate"
    >
      <mat-icon>shopping_cart</mat-icon>
    </a>
    } @if (!(isSmallScreen$ | async) && !(isAuthenticated$ | async)) {
    <button mat-button class="signin" color="accent" (click)="onLoginClick()">
      {{ 'SIGN_IN' | translate }}
    </button>
    } @else if ((isSmallScreen$ | async) && !(isAuthenticated$ | async)) {
    <button mat-icon-button class="signin" color="accent" (click)="onLoginClick()" [tippy]="'SIGN_IN' | translate">
      <mat-icon>account_circle</mat-icon>
    </button>
    }

    <ng-container *ngIf="!adminCartMode">
      <ng-container *ngIf="(isAuthenticated$ | async) && (user$ | async) as user">
        <button mat-button class="user-menu" *ngIf="!(isSmallScreen$ | async)" [matMenuTriggerFor]="toolbarUserMenu">
          <span class="full-name">{{ user.profile?.firstName }} {{ user.profile?.lastName }}</span>
          <div class="arrow-wrapper">
            <div class="arrow"></div>
          </div>
        </button>
        <button mat-icon-button class="user-menu" *ngIf="isSmallScreen$ | async" [matMenuTriggerFor]="toolbarUserMenu">
          {{ user.profile?.firstName | slice : 0 : 1 }}{{ user.profile?.lastName | slice : 0 : 1 }}
        </button>
        <mat-menu #toolbarUserMenu="matMenu">
          <a mat-menu-item *ngIf="user.isAtLeastJanitor" [routerLink]="[catalog.name, 'Admin']">{{ 'PROFILE_MENU.ADMIN' | translate }}</a>
          <a mat-menu-item *ngIf="user.isAtLeastJanitor" [routerLink]="[catalog.name, 'Admin', 'Reservations']">{{
            'PROFILE_MENU.ORDERS' | translate
          }}</a>

          <ng-container *ngIf="user.isAtLeastJanitor && catalog.id === 5341">
            <mat-divider></mat-divider>
            <a mat-menu-item target="_blank" href="/Tenants/Palfries/Pages/Rides?ride=ascent">Bergfahrten</a>
            <a mat-menu-item target="_blank" href="/Tenants/Palfries/Pages/Rides?ride=descent">Talfahrten</a>
            <a mat-menu-item target="_blank" href="/Tenants/Palfries/Pages/Rides?ride=descent&screen=true"
              >Talfahrten (Bildschirm-Ansicht)</a
            >
          </ng-container>

          <mat-divider *ngIf="user.isAtLeastJanitor"></mat-divider>
          <button mat-menu-item (click)="openMyOrders()">
            {{ 'MY_ORDERS' | translate }}
          </button>
          <button mat-menu-item (click)="onEditProfileClick()">
            {{ 'PROFILE_MENU.EDIT_PROFILE' | translate }}
          </button>
          <button mat-menu-item (click)="onPasswordChangeClick()">
            {{ 'PROFILE_MENU.CHANGE_PW' | translate }}
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="onLogoutClick()">
            <span>{{ 'PROFILE_MENU.LOGOUT' | translate }}</span>
          </button>
        </mat-menu>
      </ng-container>

      <app-language-switch></app-language-switch>
    </ng-container>
  </div>
</mat-toolbar>
